import { ENDPOINTS } from 'features/message-center/constants';
import queryString from 'query-string';
import { SECONDARY_API_CLIENT } from 'services/API';

const cleanNumber = number => number.replace(/(?!^\+)\D/g, '');

export const getConversationsV2 = async (params = {}) => {
  const queryParams = queryString.stringify(params, { arrayFormat: 'comma' });

  return SECONDARY_API_CLIENT.get(`${ENDPOINTS.conversationsV2}?${queryParams}`).then(
    ({ data }) => data
  );
};

export const searchConversations = async (params = {}) => {
  const queryParams = queryString.stringify(params, { arrayFormat: 'comma' });

  return SECONDARY_API_CLIENT.get(`${ENDPOINTS.searchByKeyword}?${queryParams}`).then(
    ({ data }) => data
  );
};
export const searchV2 = async (params = {}) => {
  const queryParams = queryString.stringify(params, { arrayFormat: 'comma' });

  return SECONDARY_API_CLIENT.get(`${ENDPOINTS.search}?${queryParams}`).then(({ data }) => data);
};

export const getConversationMessages = async (params = {}) => {
  const { externalNumber } = params;

  if (!externalNumber) return null;

  const cleanedExternalNumber = cleanNumber(externalNumber);

  const queryParams = queryString.stringify(
    { ...params, externalNumber: cleanedExternalNumber },
    { arrayFormat: 'comma' }
  );

  return SECONDARY_API_CLIENT.get(`${ENDPOINTS.messagesV2}?${queryParams}`).then(
    ({ data }) => data
  );
};

export const sendMessageToServer = async message => {
  const {
    to: rawTo,
    from: rawFrom,
    message: body,
    attachment,
    contact,
    recipient,
    sender
  } = message;
  const to = rawTo || recipient || '';
  if (!to) return null;
  const cleanedTo = cleanNumber(to);
  const from = rawFrom || sender;

  const formattedMessage = {
    to: cleanedTo,
    from,
    body,
    attachmentUrl: attachment.url,
    attachmentSize: attachment.size,
    contact
  };

  return SECONDARY_API_CLIENT.post(ENDPOINTS.messages, formattedMessage).then(({ data }) => data);
};

export const resetUnreadMessages = async (params = {}) => {
  const { externalNumber } = params;
  if (!externalNumber) return null;

  const cleanedExternalNumber = cleanNumber(externalNumber);

  const queryParams = queryString.stringify(
    { ...params, externalNumber: cleanedExternalNumber },
    { arrayFormat: 'comma' }
  );

  return SECONDARY_API_CLIENT.put(`${ENDPOINTS.resetUnreadMessages}?${queryParams}`).then(
    ({ data }) => data
  );
};

export const updateReadStatus = async ({ internalNumber, externalNumbers, status }) => {
  return SECONDARY_API_CLIENT.patch(
    ENDPOINTS.updateReadStatus.replace(':internalNumber', internalNumber),
    {
      internalNumber,
      externalNumbers,
      status
    }
  );
};
